import { useEffect, useState } from "react";

const screens = {
	"2xl": "1536px",
	lg: "1024px",
	md: "768px",
	sm: "640px",
	xl: "1280px",
} as const;

/**
 * Whether a Tailwind min-width breakpoint currently matches.
 * Defaults to `true` during SSR so desktop layout is assumed until hydrated.
 */
export const useBreakpoint = (size: keyof typeof screens) => {
	const [matches, setMatches] = useState(() => {
		if (typeof window === "undefined") return true;
		return window.matchMedia(`(min-width: ${screens[size]})`).matches;
	});

	useEffect(() => {
		const breakpoint = window.matchMedia(`(min-width: ${screens[size]})`);

		queueMicrotask(() => {
			setMatches(breakpoint.matches);
		});

		const handleChange = (value: MediaQueryListEvent) =>
			setMatches(value.matches);

		breakpoint.addEventListener("change", handleChange);
		return () => breakpoint.removeEventListener("change", handleChange);
	}, [size]);

	return matches;
};
